

//_______________ array bottle ______________

const body = $('body');

let product = '';
const productPage = $('#bottle-container');

$(document).on('click', '.nav-product', function () {

    product = productPage.data('product');
    console.log(product, 'next-product');

    productPage.addClass('blur');

});



const winesArray = [
    // {
    //     collection_name: 'Original',
    //     wine_name: 'Envie',
    //     wine_sort: 'Dry, Red, Cabernet Sauvignon',
    //     grape_variety: 'Cabernet Sauvignon',
    //     conditions: 'ALC. 542.5%',
    //     serving_temperature: '16°C - 18°C',
    //     vintage: [2010, 2015, 2019],
    //     bottle_imgs: [
    //         '/img/bottle/sinn.png' ,
    //         '/img/bottle/plesse.png',
    //         '/img/bottle/gold.png',
    //     ]
    // },
    // {
    //     collection_name: 'Original',
    //     wine_name: 'Gioveni',
    //     wine_sort: 'Dry, Rose',
    //     grape_variety: 'Sauvignon 456',
    //     conditions: 'ALC. 12.5%',
    //     serving_temperature: '1546°C - 1867°C',
    //     vintage: [2010, 2015],
    //     bottle_imgs: [
    //         '/img/bottle/plesse.png',
    //         '/img/bottle/gold.png',
    //     ]
    // },
    // {
    //     collection_name: 'Original',
    //     wine_name: 'Virginette',
    //     wine_sort: 'Dry, Red, Merlot',
    //     grape_variety: 'Cabernet dsfg',
    //     conditions: 'ALC. 35.5%',
    //     serving_temperature: '156°C - 13°C',
    //     vintage: [2019],
    //     bottle_imgs: [
    //         '/img/bottle/gold.png',
    //     ]
    // },
]

const app = function ($) {

    const winesSlider = () =>{

        let mainCount = -1;

        function vintageItem (year, index) {
            return `<div class="vintage-item" data-item="${index}">
                       <img class="svg" src="/img/vintage-big.svg" alt="">
                       <span>${year}</span>
                      </div>`
        };

        const bottleCollection = $('.bottle-collection');
        const bottleTitle = $('.bottle-title');
        const bottleDescription = $('.bottle-description');
        const grapeVariety = $('.grape-variety');
        const conditions = $('.conditions');
        const temperature = $('.temperature');
        const vintageEl = $('.vintage');
        const vintageItemEl = vintageEl.find('.vintage-item')
        const bottleImg = $('.bottle-item-img img');

        const prevBtn = $('.prev-btn');
        const nextBtn = $('.next-btn');

        prevBtn.click(function () {
            const t = $(this)
            if(mainCount > 0 ) {
                mainCount--;
                switchWine()
                // console.log(mainCount)
                ifHasClassRemove(nextBtn)
                if(mainCount === 0){
                    t.addClass('disabled')
                }
            }

        })

        nextBtn.click(function () {
            const t = $(this)

            if(mainCount  < winesArray.length - 1  ){
                mainCount++
                switchWine()
                ifHasClassRemove(prevBtn)
                if (mainCount  === winesArray.length - 1 ){
                    t.addClass('disabled')

                }
            }
            // console.log(mainCount)
        })

        function ifHasClassRemove(element){
            if($(element).hasClass('disabled')){
                $(element).removeClass('disabled')
            }
        }

        body.on('click','.vintage-item', function () {
            onClickVintageBottle($(this))
        })

        function switchWine() {
            updateWineInfo(winesArray[mainCount])
        }

        function updateWineInfo(Obj) {
            bottleCollection.text(Obj.collection_name);
            bottleTitle.text(Obj.wine_name);
            bottleDescription.text(Obj.wine_sort);
            grapeVariety.text(Obj.grape_variety);
            conditions.text(Obj.condition);
            temperature.text(Obj.serving_temperature);
            vintageEl.html(renderVintage(Obj.vintage));
            svgHandle();
            vintageEl.find('.vintage-item').eq(0).addClass('active');
            setBottleImg(Obj.bottle_imgs[0]);

        }

        function renderVintage(array) {
            let html = '';
            array.forEach((item, index) =>{
                html += vintageItem(item, index)
            } );
            return html
        }

        function setBottleImg(imgSrc) {
            bottleImg.attr('src', imgSrc)
        }

        function onClickVintageBottle(bottle){
            const dataIndex = $(bottle).data('item');
            vintageEl.find('.vintage-item').removeClass('active');
            $(bottle).addClass('active')
            setBottleImg(winesArray[mainCount].bottle_imgs[dataIndex])
        }
    };

    const svgHandle = () => {
        $('body').find('img.svg').each(function () {
            let img = $(this);
            let imgID = img.attr('id');
            let imgClass = img.attr('class');
            let imgUrl = img.attr('src');
            $.get(imgUrl, function (data) {
                let svg = $(data).find('svg');
                if (typeof imgID !== 'undefined') {
                    svg = svg.attr('id', imgID);
                }
                if (typeof imgClass !== 'undefined') {
                    svg = svg.attr('class', imgClass + ' replaced-svg');
                }
                svg = svg.removeAttr('xmlns:a');
                img.replaceWith(svg);
            }, 'xml');
        });
    }

    return {
        init() {
            // imgSvgHandle();
            winesSlider();
            svgHandle();

        }
    }
};

// const app = function ($) {
//     const winesAwards = () =>{
// }

jQuery(document).ready(function ($) {
    app($).init();
});



//______________ Reviews _________________

var swiper = new Swiper('.swiper-reviews', {
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});


//______________ page mob-wine _________________

var swiper = new Swiper('.swiper-mob-wine', {
    pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});


//______________ error validation ________________

(function() {
    'use strict';
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();


//______________ favicon dark mode ________________

window.addEventListener( 'DOMContentLoaded', setFavicon );

function setFavicon() {

    if ( window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ) {
        const favicon = document.querySelector('[data-dark]');
        if ( ! favicon ) {
            return;
        }
        if ( favicon.dataset.dark ) {
            favicon.href = favicon.dataset.dark;
        }
    }
}


//______________ auto resize textarea (page contacts) _________________

const textarea = document.querySelector('textarea');

if(textarea){
    textarea.addEventListener('keydown', autosize);
}

function autosize(){
    const t = this;
    setTimeout(function(){
        t.style.cssText = 'height:auto; padding:0;';
        t.style.cssText = 'height:' + t.scrollHeight + 'px';
    },0);
}

//______________________Page Blog _________________________

// $( document ).ready(function() {
//     $('.item-article span.text-columns').parent().addClass('two-columns');
// });

//______________ mobile-menu-toogler __________

const mainNavbar = $('.main-navbar-collapse');

mainNavbar.on('shown.bs.collapse', function () {
        $('body').addClass('modal-open');
});
mainNavbar.on('hidden.bs.collapse', function () {
    $('body').removeClass('modal-open');
});

//_______________ Lang switcher ________________
$(".lang-switcher a").click(function(e) {

    if ($(this).hasClass('current')) {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $('.lang-switcher').css('height', '0');
        } else {
            $(this).addClass('open');
            var height = $('.lang-switcher a').length;
            $('.lang-switcher').css('height', (height - 1) * 30);
        }
    } else {
        $('.lang-switcher a').removeClass('current');
        $('.lang-switcher').css('height', '0');
        $(this).addClass('current');
        location.href = $(this).attr(href);
    }
    e.preventDefault()
});


//new


// const homePage = $('.home-page')
//
// if(homePage.length > 0){
//     const carouselItem =  $('.carousel-item')
//
//     const setBgWidth = () => {
//         carouselItem.each(function (){
//             const t = $(this)
//             t.attr('style', `${'--carousel-bg-width:'+  window.innerWidth + 'px !important'}`)
//
//         })
//     }
//     if(carouselItem.length > 0){
//
//         if(window.innerWidth > 1000 ){
//             setBgWidth()
//
//             $(window).resize(function (e){
//                 setBgWidth()
//             })
//         }
//
//     }
//
// }



const setFixedHeaderMenu = () => {




        // const pageProductsEl = $('.page-products-category')


        const headerContainerEl =  $('.header-container')
        const headerMenuEl =  $('.header-top')


        let lastScroll = null
        let showFixedMenu = false

        let minShowPx =  300
        let minFirstShowPx =  450

    const hideMenuHandle = () =>{

        setTimeout( () => {
            headerMenuEl.addClass('hide-fixed-state')
             setTimeout( () => {
                 headerMenuEl.removeClass('fixed-state')
                 headerContainerEl.removeClass('fixed-menu')
                 headerMenuEl.removeClass('hide-fixed-state')

             }, 300);
            showFixedMenu = false
        }, 0);
    }

        $(window).on('scroll', function (e) {
            const currentScroll = $(e.target).scrollTop()

            if (showFixedMenu && currentScroll > lastScroll) {
                //down
                if(currentScroll - lastScroll > 13){
                    hideMenuHandle()
                }
            }
            if (currentScroll < lastScroll) {
                //up
                if ( lastScroll - currentScroll > 13) {
                    if (currentScroll > minFirstShowPx) {

                        headerContainerEl.addClass('fixed-menu')
                        setTimeout( () => {
                            headerMenuEl.addClass('fixed-state')
                        }, 0);

                        showFixedMenu = true
                    }
                }
            }

            if (currentScroll < minShowPx) {

                hideMenuHandle()

            } else {

            }
            lastScroll = currentScroll
        })


}

setFixedHeaderMenu()
